import { Injectable, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { AutomationScheduleType, AutomationTimings, OccurenceType } from '@fitness-force/enum';
import type { Country, LANGUAGE, ReportFormBase } from '@fitness-force/models';
import { RelativeDate } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { COMPANY_INFO, COUNTRY_MASTER_STATE, COUNTRY_MASTER_STATE_LIST } from '@fitness-force/state';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { LOCALE_ID } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class CommonService {
  store = inject(Store);
  translateService = inject(TranslateService);
  locale = inject(LOCALE_ID);

  private timePeriod: any;
  miner_currency = new BehaviorSubject(0);
  saveSettings =  new BehaviorSubject(false);
  companyDetails: any;
  currencyCode:string = '';

  private newProspectCreated:Subject<boolean> = new BehaviorSubject<boolean>(false);
  private countries: Country[] = [];

  constructor(){
    this.store.select(COUNTRY_MASTER_STATE).subscribe((country:Country) => {
      if(country){
        this.miner_currency.next(country.miner_currency);
        this.currencyCode = country.currency_code;
      }
    });

    this.store.select(COUNTRY_MASTER_STATE_LIST).subscribe((countries: Country[]) => {
      if (countries) {
        this.countries = countries;
      }
    });
    
    this.store.select(COMPANY_INFO).subscribe({
      next: (comp) => {
        this.companyDetails = comp;
      },
      error: (err:any) => { 
        console.log(err);
      },
    });
  }

  get newProspectCreated$(){
    return this.newProspectCreated.asObservable();
  }


  get parseSupportedLang(): Array<LANGUAGE> {
    let supportedLangBuffer: Array<LANGUAGE> = [];
    const supportedLang =
      this.companyDetails.compDetails.supported_languages.map((l: any) =>
        l.trim().toLowerCase()
      );

    supportedLangBuffer = CONSTANTS_DATA.ALL_LANGUAGES.filter((lang) => {
      const languageOnlower = lang.LANG_ABBRE.toLowerCase();
      const langCodeOnlower = lang.LANG_CODE.toLowerCase();
      if (supportedLang && supportedLang.length > 0) {
        return (
          supportedLang &&
          (supportedLang.includes(languageOnlower) ||
            supportedLang.includes(langCodeOnlower))
        );
      } else if (
        this.companyDetails.compDetails.primary_language == languageOnlower
      ) {
        return lang;
      } else {
        return { COUNTRY: 'us', LANG_CODE: 'en', LANG_ABBRE: 'ENGLISH' };
      }
    });

    return supportedLangBuffer;
  }



  addProspect(created:boolean) {
    this.newProspectCreated.next(created);
  }

  GetRelativeFromDate(date: Date, relativeDate: RelativeDate, day: number) {
    const relativeDates: any = { from_date: Date, to_date: Date };
    switch (relativeDate) {
      case RelativeDate.Today: {

        relativeDates.from_date = new Date(new Date().setHours(0, 0, 0));
        relativeDates.to_date = new Date(new Date().setHours(23, 59, 59));
        return relativeDates;
      }

      case RelativeDate.Tomorrow: {
        const tomorrow=date.setDate(date.getDate() + day)
        {
          relativeDates.from_date = new Date(new Date(
            tomorrow
          ).setHours(0, 0, 0));
          relativeDates.to_date = new Date(new Date(
            tomorrow
          ).setHours(23, 59, 59));
          return relativeDates;
        }
      }
      case RelativeDate.ThisMonth: {
        relativeDates.from_date = new Date(date.getFullYear(), date.getMonth(), 1);
        relativeDates.to_date = new Date(date.getFullYear(), date.getMonth() + 1, 0,23,59,59);
        return relativeDates;
      }
      case RelativeDate.ThisQuarter: {
        const quarter = Math.floor((date.getMonth() / 3));
        const firstDate = new Date(date.getFullYear(), quarter * 3, 1);
        const endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);
        relativeDates.from_date = firstDate;
        relativeDates.to_date = endDate;
        return relativeDates;
      }
      case RelativeDate.Yesterday: {
        const yesterday=date.setDate(date.getDate() + day)
        relativeDates.from_date = new Date(new Date(yesterday).setHours(0, 0, 0));
        relativeDates.to_date =  new Date(new Date(yesterday).setHours(23, 59, 59));
        return relativeDates;
      }
      case RelativeDate.LastSevenDays: {
        relativeDates.from_date = new Date(new Date(date.setDate(date.getDate() + RelativeDate.LastSevenDays)).setHours(0, 0, 0));
        relativeDates.to_date =  new Date(new Date().setHours(0, 0, 0));
        return relativeDates;
      }
      case RelativeDate.LastMonth: {
        relativeDates.from_date = new Date(
          date.getFullYear(),
          date.getMonth() - 1,
          1
        );
        relativeDates.to_date = new Date(
          new Date(date.getFullYear(), date.getMonth(), 1,23,59,59).setDate(
            relativeDates.from_date.getDate() - 1
          )
        );
        return relativeDates;
      }
      case RelativeDate.LastThirtyDays: {
        relativeDates.from_date = new Date((date.setDate(date.getDate() + RelativeDate.LastThirtyDays)));
        relativeDates.to_date = new Date(date.setHours(23, 59, 59));
        return relativeDates;
      }
      case RelativeDate.CustomDateRange: {
        relativeDates.from_date = new Date(date.setHours(0, 0, 0));;
        relativeDates.to_date = new Date(date.setHours(23, 59, 59));
        return relativeDates;
      }
      default:
        return date;
    }
  }

  GetRelativeToDate(date: Date, relativeDate: RelativeDate, day: number) {
    switch (relativeDate) {
      case RelativeDate.Today:
        return new Date();
      case RelativeDate.Tomorrow: {
        return date.setDate(date.getDate() + day);
      }
      case RelativeDate.ThisMonth: {
        return new Date();
      }
      case RelativeDate.ThisQuarter:
        return new Date();
      case RelativeDate.Yesterday: {
        return date.setDate(date.getDate() + day);
      }
      case RelativeDate.LastSevenDays: {
        return date;
      }
      case RelativeDate.LastMonth: {
        const lastMonth: Date = new Date(date.getFullYear(), date.getMonth(), 1);
        return lastMonth.setDate(lastMonth.getDate() - 1);
      }
      case RelativeDate.LastThirtyDays: {
        return date;
      }
      case RelativeDate.CustomDateRange: {
        return date;
      }
      default:
        return date;
    }
  }

  toFormGroup(fields: ReportFormBase<string>[]) {
    const group: any = {};
    fields.forEach((field) => {
      // Preserve arrays (for multiselect) - don't replace with empty string
      const defaultValue = Array.isArray(field.value) ? field.value : (field.value || '');
      group[field.key] = field.required
        ? new UntypedFormControl(defaultValue, Validators.required)
        : new UntypedFormControl(defaultValue);
    });

    return new UntypedFormGroup(group);
  }

  GetTimePeriods() {
    return (this.timePeriod = [
      {
        name: 'Yesterday',
        label: 'Yesterday',
        value: -1,
        date: this.GetRelativeFromDate(new Date(), RelativeDate.Yesterday, -1),
      },
      {
        name: 'Today',
        label: 'Today',
        value: 0,
        date: this.GetRelativeFromDate(new Date(), RelativeDate.Today, 0),
      },
      {
        name: 'Tomorrow',
        label: 'Tomorrow',
        value: 1,
        date: this.GetRelativeFromDate(new Date(), RelativeDate.Tomorrow, 1),
      },
      {
        name: 'ThisMonth',
        label: 'This Month',
        value: 3,
        date: this.GetRelativeFromDate(new Date(), RelativeDate.ThisMonth , 0),
      },
      // {
      //   name: 'ThisMonth',
      //   label: 'This Month',
      //   value: 4,
      //   date: this.GetRelativeFromDate(new Date(), RelativeDate.ThisMonth, 0),  // for This month end
      // },
      {
        name: 'ThisQuarter',
        label: 'This Quarter',
        value: 33,
        date: this.GetRelativeFromDate(new Date(), RelativeDate.ThisQuarter, 1),
      },
      // {
      //   name: 'ThisQuarter',
      //   label: ' This Quarter',
      //   value: 33,
      //   date: this.GetRelativeFromDate(new Date(), RelativeDate.ThisQuarter, 1),
      // },
      {
        name: 'LastSevenDays',
        label: 'Last Seven Days',
        value: -7,
        date: this.GetRelativeFromDate(
          new Date(),
          RelativeDate.LastSevenDays,
          -7
        ),
      },

      {
        name: 'LastThirtyDays',
        label: 'Last Thirty Days',
        value: -30,
        date: this.GetRelativeFromDate(
          new Date(),
          RelativeDate.LastThirtyDays,
          -30
        ),
      },
      {
        name: 'LastMonth',
        label: 'Last Month',
        value: -3,
        date: this.GetRelativeFromDate(new Date(), RelativeDate.LastMonth, 0),
      },
      {
        name: 'CustomDateRange',
        label: 'Custom Date Range',
        value: 99,
        date: { from_date: new Date(), to_date: new Date() },
      },
    ]);
  }

  // Convert minur currency amount in currency amount
  ConvertAmountFromMinorCurrency(currencyAmount:number){
    if(this.miner_currency && this.miner_currency.value > 0)
    {
      const currencyMultiplier = Math.pow(10, this.miner_currency.value);
      currencyAmount = (currencyAmount / currencyMultiplier);
      return currencyAmount;
    }
    else{
      const error:Error ={} as Error;
        error.name='invaid_currency_code';
        error.message="something went wrong, please reload";
        throw error;
    }
    
  }

  // Convert currency amount in  minur currency amount
  ConvertMinorCurrencyFromAmount(currencyAmount:number){
    if(this.miner_currency && this.miner_currency.value > 0)
    {
    const currencyMultiplier = Math.pow(10, this.miner_currency.value);
    // Changed for 79.99 gets converted to 79.98, ceil working fine
     currencyAmount = Math.fround(currencyAmount * currencyMultiplier);
    return currencyAmount;
    }

    else{
      const error:Error ={} as Error;
        error.name='invaid_currency_code';
        error.message="something went wrong, please reload";
        throw error;
    }
  }

  ConvertMinorCurrencyFromAmountRounded(currencyAmount:number){
    const currencyMultiplier = Math.pow(10, this.miner_currency.value);
    // Changed for 79.99 gets converted to 79.98, ceil working fine
     currencyAmount = Math.round(currencyAmount * currencyMultiplier);
    return currencyAmount;
  }


  GetNationalidLocalization(): Observable<any> {
    let nationalIdObj: any = {};
    this.store.select(COUNTRY_MASTER_STATE).subscribe((country: Country) => {
      if (country) {
        switch (country.three_letter_code.toLowerCase()) {
          case 'ind':
            nationalIdObj = { label: 'NATIOAN_ID_LABEL.AADHAR', errorLabel: 'NATIOAN_ID_LABEL.AADHAR' };
            break;
          case 'sau':
            nationalIdObj = { label: 'NATIOAN_ID_LABEL.NATIONAL_ID', errorLabel: 'NATIOAN_ID_LABEL.NATIONAL_ID' };
            break;
          case 'usa':
             nationalIdObj = { label: 'NATIOAN_ID_LABEL.NATIONAL_ID', errorLabel: 'NATIOAN_ID_LABEL.NATIONAL_ID' };
            break;
          default:
            nationalIdObj = { label: 'NATIOAN_ID_LABEL.NATIONAL_ID', errorLabel: 'NATIOAN_ID_LABEL.NATIONAL_ID' };
        }
      }
    });
  
    return of(nationalIdObj);
  }

  createKeyValueArray(scheduleType: AutomationScheduleType, timing:string, eventType:AutomationTimings): { key: string; value: number }[] {
       const result: { key: string; value: number }[] = [];
       let key: string;
      switch (scheduleType) {
        case AutomationScheduleType.Day:
          {
            for (let i = 1; i <= 100; i++) {
              key = `${i} day${i > 1 ? 's' : ''} ${timing}`;
              const calculatedValue = this.calculateValueInMinutes(scheduleType, i, eventType);
              result.push({ key, value: calculatedValue });
            }
            // Add specific values after 100
            const additionalDays = [125, 150, 175, 186, 200, 250, 300, 365];
            additionalDays.forEach(day => {
              key = `${day} days ${timing}`;
              const calculatedValue = this.calculateValueInMinutes(scheduleType, day, eventType);
              result.push({ key, value: calculatedValue });
            });
          }
          
          break;
        case AutomationScheduleType.Hour:
          {
            for (let i = 1; i <= 24; i++) {
              key = `${i} hour${i > 1 ? 's' : ''} ${timing}`;
              const calculatedValue = this.calculateValueInMinutes(scheduleType, i, eventType);
              result.push({ key, value: calculatedValue });
            }
          }
          break;
        case AutomationScheduleType.Minute:
          {
            for (let i = 1; i <= 24 * 60; i++) {
              key = `${i * 30} minutes ${timing}`;
              const calculatedValue = this.calculateValueInMinutes(scheduleType, i, eventType);
              result.push({ key, value: calculatedValue });
              
            }
          }
          break;
        default:
          result.push({ key:"", value: 0 });
    }
    return result;
  }

  private calculateValueInMinutes(scheduleType: AutomationScheduleType, count: number, eventType:AutomationTimings): number {
    switch (scheduleType) {
      case AutomationScheduleType.Day:
        {
          // const targetDate = this.calculateDateFromEventType(eventType, count)
          // targetDate.setHours(0, 0, 0, 0);
          // return this.calculateMinutesFromToday(targetDate);
          if (eventType === AutomationTimings.Before) {
            return  (-count) * 24 * 60;
          } else if (eventType === AutomationTimings.After) {
            return  (count) * 24 * 60;
          } else {
            return count * 24 * 60;
          }
        }
      case AutomationScheduleType.Hour:
        {
          if (eventType === AutomationTimings.Before) {
            return  60 * (-count);
          } else if (eventType === AutomationTimings.After) {
            return  60 * count;
          } else {
            return  60 * count;
          }
        }
        // return  60 * count;
      case AutomationScheduleType.Minute:
        {
          if (eventType === AutomationTimings.Before) {
            return 30 * (-count);
          } else if (eventType === AutomationTimings.After) {
            return 30 * count;
          } else {
            return 30 * count;
          }
        }
        // return 30 * count;
      default:
        return 0;
    }
  }

  calculateDateFromEventType(eventType: AutomationTimings, value: number): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (eventType === AutomationTimings.Before) {
      return new Date(today.getTime() - value * 24 * 60 * 60 * 1000);
    } else if (eventType === AutomationTimings.After) {
      return new Date(today.getTime() + value * 24 * 60 * 60 * 1000);
    } else {
      return today;
    }
  }

  calculateMinutesFromToday(targetDate: Date): number {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const differenceInMillis = targetDate.getTime() - today.getTime();
    const differenceInMinutes = differenceInMillis / (1000 * 60);
    return differenceInMinutes;
  }

  generateGuid(): string {
    const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  generateDepositOccurence(selectedOccurrenceType: string, contractTerms: number): { key: string; value: number, selected:boolean,occurenceType: string }[] {
    const result: { key: string; value: number, selected:boolean , occurenceType: string}[] = [];
    const occurrenceType = OccurenceType[selectedOccurrenceType as keyof typeof OccurenceType];
  
    const getKey = (i: number, suffix: string, extra:string=''): string => `${i}${suffix} Occurrence ${extra}`;
    const getLastKey = (i: number, suffix: string,extra:string=''): string => `${i}${suffix} Last Occurrence ${extra}`;
  
    switch (occurrenceType) {
      case OccurenceType.AutoApplyOnOccurence:
        for (let i = 1; i <= contractTerms; i++) {
          const key = getKey(i, i <= 3 ? ['st', 'nd', 'rd'][i - 1] : 'th');
          if(i == 1)
          {
            const newkey = getKey(i, i <= 3 ? ['st', 'nd', 'rd'][i - 1] : 'th','(Included in signup)');
            result.push({ key:newkey, value: i, selected:true , occurenceType: selectedOccurrenceType});
          }
          else result.push({ key, value: i ,selected:false , occurenceType: selectedOccurrenceType});
        }
        break;
      case OccurenceType.AutoApplyBeforeCancellation:
        for (let i = 1; i <= contractTerms; i++) {
          const key = getLastKey(i, i <= 3 ? ['st', 'nd', 'rd'][i - 1] : 'th');
          const occurrenceValue = -i;
          //result.push({ key: i === 1 ? 'Last Occurrence' : key, value: occurrenceValue, selected:false ,occurenceType: selectedOccurrenceType});
          if(i == contractTerms)
          {
            const newkey = getKey(i, i <= 3 ? ['st', 'nd', 'rd'][i - 1] : 'th','(Included in signup)');
            result.push({ key:newkey, value: occurrenceValue, selected:true ,occurenceType: selectedOccurrenceType});
          }
          else result.push({ key: i === 1 ? 'Last Occurrence' : key, value: occurrenceValue, selected:false ,occurenceType: selectedOccurrenceType});
        }
        break;
        case OccurenceType.ApplyManually:
          for (let i = 1; i <= contractTerms; i++) {
            const key = getKey(i, i <= 3 ? ['st', 'nd', 'rd'][i - 1] : 'th');
            result.push({ key, value: 0,selected:false,occurenceType: selectedOccurrenceType });
          }
          break;
      default:
        result.push({ key: '', value: 0 ,selected:false,occurenceType: selectedOccurrenceType });
        break;
    }
    return result;
  }

  formatScheduleTime(scheduleInMinutes: number, automationType: string): { key: string; name: string; value: number } {
    const scheduleTime: { key: string; name: string; value: number } = { key: '', name: '', value: 0 };
  
    if (scheduleInMinutes !== 0) {
      const timing = `(${scheduleInMinutes > 0 ? 'After' : scheduleInMinutes < 0 ? 'Before' : 'Immediate'} ${this.translateService.instant('AUTOMATION.EVENT.' + automationType)})`;
  
      const absMinutes = Math.abs(scheduleInMinutes);
      let formattedTime: string;
  
      if (absMinutes % 1440 === 0) {
        const key = absMinutes / 1440 > 1 ? 'days' : 'day';
        formattedTime = `${absMinutes / 1440} ${key} ${timing}`;
        scheduleTime.key = "Day";
      } else if (absMinutes % 60 === 0) {
        const key = absMinutes / 60 > 1 ? 'hours' : 'hour';
        formattedTime = `${absMinutes / 60} ${key} ${timing}`;
        scheduleTime.key = "Hour";
      } else {
        formattedTime = `${absMinutes} minutes ${timing}`;
        scheduleTime.key = "Minute";
      }
  
      scheduleTime.name = formattedTime;
      scheduleTime.value = scheduleInMinutes;
    }
  
    return scheduleTime;
  }

  public async convertToImage(element: HTMLElement): Promise<string> {
    return new Promise(async (resolve, reject) => {
      try {
        // Dynamic import to reduce initial bundle size
        const html2canvas = (await import('html2canvas')).default;
        
        html2canvas(element).then((canvas: any) => {
          const imgData = canvas.toDataURL('image/png'); // Get image as data URL (Base64)
          resolve(imgData);
        }).catch((error: any) => {
          reject(error);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  getAmountFromMinorCurrencyAmount(currencyAmount:number, currencyCode:string):number{
    let amount = 0;
    if(currencyAmount && currencyCode)
    {
      this.store.select(COUNTRY_MASTER_STATE_LIST).subscribe((countries: Country[]) => {
        if (countries) {
          const minerCurrency = countries.find(country => country.currency_code.toLowerCase() === currencyCode.toLowerCase());
          if(minerCurrency)
          {
            const currencyMultiplier = Math.pow(10, minerCurrency.miner_currency);
            amount = (currencyAmount / currencyMultiplier);
          }
        }
      });
    }
    return amount;
  }

  // Convert currency amount in  minur currency amount
  getMinorCurrencyAmountFromAmount(currencyAmount:number, currencyCode:string):number{
    let amount = 0;
    if(currencyAmount && currencyCode)
    {
      this.store.select(COUNTRY_MASTER_STATE_LIST).subscribe((countries: Country[]) => {
        if (countries) {
          const minerCurrency = countries.find(country => country.currency_code.toLowerCase() === currencyCode.toLowerCase());
          if(minerCurrency)
          { 
            const currencyMultiplier = Math.pow(10, minerCurrency.miner_currency);
            amount = Math.fround(currencyAmount * currencyMultiplier);
          }
        }
      });
    }
    return amount;
  }

  getCurrencyCodeAndLocale():{currencyCode:string, locale:string}{
    return {currencyCode: this.currencyCode, locale: this.locale};  
  }

  getMinorCurrencyDecimalPlaces(currencyCode?: string): number {
    if (currencyCode) {
      const country = this.countries.find(
        (c) => c.currency_code.toLowerCase() === currencyCode.toLowerCase()
      );
      if (country) {
        return country.miner_currency;
      }
    }
    return this.miner_currency.value;
  }

  getCurrencyDigitsInfo(decimalPlaces: number): string {
    const places = decimalPlaces > 0 ? decimalPlaces : 2;
    return `1.${places}-${places}`;
  }


}
